export function appendHttpsSchemeIfNecessary(url: string): string {
  // keep URL in case of :// or protocol: (e.g. mailto:)
  if (url.match(/:\/\//) || url.match(/^\w+:/)) {
    return url;
  }
  return `https://${url}`;
}
